/* global
  openS360, mgmtQtyForYear, mgmtExpenseForYear,
  opsUpdateMonth, opsCategoryClick, opsCloseDetail, opsShowDetail,
  vendPillFor, vendActionText, vendUpdateFilterBar, vendParseAmt,
  vendFormatL, renderVendPOs, vendApplyKpis, vendCloseDetail,
  vendRenderInvoiceStages, vendRenderPaymentCenter, vendRenderActionCenter,
  vendRenderUpcomingDeliveries, ensureS360Perf, s360tab
*/
import Chart from 'chart.js/auto';

const dashboardCharts = [];

export function initBaseDashboard(){
dashboardCharts.forEach(chart => chart.destroy());
dashboardCharts.length = 0;

const muted='#9CA0B5', grid='#EDEEF4';
Chart.defaults.font.family=getComputedStyle(document.documentElement).getPropertyValue('--font-body').trim(); Chart.defaults.color='#6B7089'; Chart.defaults.font.size=11;
function createChart(id, options){
  const canvas=document.getElementById(id);
  if(!(canvas instanceof HTMLCanvasElement)) return null;

  const chart = new Chart(canvas, options);
  dashboardCharts.push(chart);
  return chart;
}
function baseGrid(){return {grid:{color:grid,drawTicks:false}, border:{display:false}, ticks:{color:muted}};}

/* ============ FINANCE DATA + INTERACTIONS ============ */
const finMonths=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug'];
const finCatByMonth={
  Jan:[24,20,12,8,6], Feb:[26,21,13,9,7], Mar:[27,22,13,9,7], Apr:[29,23,14,10,7],
  May:[31,24,15,10,8], Jun:[30,25,15,10,8], Jul:[32,26,17,11,9], Aug:[34,26,18,12,10]
};
const finCatLabels=['Medicine','Raw material','Equipment','Packaging','Logistics'];
const finKpiByMonth={
  Jan:{spend:'₹62.0L',overdue:'₹2.1L',savings:'₹0.8L',budget:'68%'},
  Feb:{spend:'₹68.4L',overdue:'₹2.8L',savings:'₹0.9L',budget:'70%'},
  Mar:{spend:'₹71.2L',overdue:'₹3.4L',savings:'₹1.0L',budget:'71%'},
  Apr:{spend:'₹75.6L',overdue:'₹4.0L',savings:'₹1.1L',budget:'70%'},
  May:{spend:'₹80.1L',overdue:'₹4.6L',savings:'₹1.2L',budget:'71%'},
  Jun:{spend:'₹79.3L',overdue:'₹5.2L',savings:'₹1.3L',budget:'71%'},
  Jul:{spend:'₹83.0L',overdue:'₹6.1L',savings:'₹1.35L',budget:'72%'},
  Aug:{spend:'₹84.2L',overdue:'₹7.24L',savings:'₹1.4L',budget:'72%'}
};
// Every outstanding (non-paid) invoice carries payablesBucket (due-today / due-7 / due-30 / 31-60 / overdue),
// aging (current / 1-30 / 31-60 / 61-90 / 90+), an optional exception category, and dueInDays (negative = overdue).
const finInvoices=[
  {inv:'INV-2988',vendor:'AHB Pharma',amt:'₹98,000',due:'12 Jan 2026',days:0,status:'paid',month:'Jan'},
  {inv:'INV-3001',vendor:'MediLife Ltd',amt:'₹1,20,000',due:'20 Mar 2026',days:0,status:'paid',month:'Mar'},
  {inv:'INV-3006',vendor:'XYZ Chemicals',amt:'₹64,000',due:'18 May 2026',days:0,status:'paid',month:'May'},
  {inv:'INV-3009',vendor:'XYZ Chemicals',amt:'₹78,500',due:'08 Aug 2026',days:10,status:'overdue',month:'Aug',payablesBucket:'overdue',aging:'1-30',exception:null,dueInDays:-10},
  {inv:'INV-3021',vendor:'AHB Pharma',amt:'₹1,45,000',due:'02 Aug 2026',days:16,status:'overdue',month:'Aug',payablesBucket:'overdue',aging:'1-30',exception:'approval-pending',dueInDays:-16},
  {inv:'INV-3044',vendor:'MediLife Ltd',amt:'₹2,10,000',due:'14 Aug 2026',days:4,status:'pending',month:'Aug',payablesBucket:'overdue',aging:'1-30',exception:'price-mismatch',dueInDays:-4},
  {inv:'INV-3051',vendor:'HealthCorp',amt:'₹56,200',due:'16 Aug 2026',days:2,status:'pending',month:'Aug',payablesBucket:'overdue',aging:'1-30',exception:null,dueInDays:-2},
  {inv:'INV-3060',vendor:'BioGen',amt:'₹92,000',due:'18 Aug 2026',days:0,status:'pending',month:'Aug',payablesBucket:'due-today',aging:'current',exception:null,dueInDays:0},
  {inv:'INV-3063',vendor:'Vedica Store',amt:'₹1,18,000',due:'23 Aug 2026',days:0,status:'pending',month:'Aug',payablesBucket:'due-7',aging:'current',exception:'po-mismatch',dueInDays:5},
  {inv:'INV-3072',vendor:'BioGen',amt:'₹70,000',due:'20 Aug 2026',days:0,status:'pending',month:'Aug',payablesBucket:'due-7',aging:'current',exception:'approval-pending',dueInDays:2},
  {inv:'INV-3075',vendor:'Vedica Store',amt:'₹50,000',due:'21 Aug 2026',days:0,status:'pending',month:'Aug',payablesBucket:'due-7',aging:'current',exception:'approval-pending',dueInDays:3},
  {inv:'INV-3067',vendor:'AHB Pharma',amt:'₹1,60,000',due:'10 Sep 2026',days:0,status:'pending',month:'Aug',payablesBucket:'due-30',aging:'current',exception:'qty-mismatch',dueInDays:23},
  {inv:'INV-3070',vendor:'HealthCorp',amt:'₹88,500',due:'25 Sep 2026',days:0,status:'pending',month:'Aug',payablesBucket:'31-60',aging:'current',exception:'missing-docs',dueInDays:38},
  {inv:'INV-2950',vendor:'XYZ Chemicals',amt:'₹74,000',due:'30 Jun 2026',days:49,status:'overdue',month:'Jun',payablesBucket:'overdue',aging:'31-60',exception:'tax-issue',dueInDays:-49},
  {inv:'INV-2940',vendor:'BioGen',amt:'₹43,600',due:'05 Jun 2026',days:74,status:'overdue',month:'Jun',payablesBucket:'overdue',aging:'61-90',exception:null,dueInDays:-74},
  {inv:'INV-2905',vendor:'MediLife Ltd',amt:'₹1,16,300',due:'10 May 2026',days:100,status:'overdue',month:'May',payablesBucket:'overdue',aging:'90+',exception:'missing-docs',dueInDays:-100},
];
let finMonthFilter='Aug', finStatusFilter=null, finExtraFilter=null;

const payablesBucketLabel={'due-today':'Due today','due-7':'Due <7 days','due-30':'Due 8–30 days','31-60':'31–60 days','overdue':'Overdue'};
const agingBucketLabel={'current':'Current','1-30':'1–30 days','31-60':'31–60 days','61-90':'61–90 days','90+':'90+ days'};
const exceptionLabel={'po-mismatch':'PO mismatch','price-mismatch':'Price mismatch','qty-mismatch':'Quantity mismatch','missing-docs':'Missing documents','tax-issue':'Tax issue','approval-pending':'Approval pending'};

function pillFor(status){
  if(status==='paid') return '<span class="pill green">Paid</span>';
  if(status==='overdue') return '<span class="pill red">Overdue</span>';
  return '<span class="pill amber">Pending</span>';
}
 function clearActiveHighlights(){
  document.querySelectorAll('#finPayablesBreakdown .funnel-row').forEach(r=>r.classList.remove('active'));
  document.querySelectorAll('#finWindowTiles .payable-tile').forEach(t=>t.classList.remove('active'));
  document.querySelectorAll('#finExceptionGrid .exception-chip').forEach(c=>c.classList.remove('active'));
}
function renderFinInvoices(){
  const activeFilterTag = document.getElementById('finActiveFilterTag');
  const count = document.getElementById('finInvCount');
  const title = document.getElementById('finInvTitle');
  const body = document.getElementById('finInvBody');
  if (!activeFilterTag || !count || !title || !body) return;

  let rows, titleBase;
  if(finExtraFilter){
    rows = finInvoices.filter(r=>{
      if(r.status==='paid') return false;
      if(finExtraFilter.type==='payables') return r.payablesBucket===finExtraFilter.value;
      if(finExtraFilter.type==='aging') return r.aging===finExtraFilter.value;
      if(finExtraFilter.type==='window') return r.dueInDays!=null && r.dueInDays>=0 && r.dueInDays<=finExtraFilter.value;
      if(finExtraFilter.type==='exception') return r.exception===finExtraFilter.value;
      return true;
    });
    titleBase = finExtraFilter.label;
    activeFilterTag.style.display='inline-flex';
  } else {
    rows = finInvoices.filter(r=>r.month===finMonthFilter);
    titleBase = finMonthFilter+' 2026';
    activeFilterTag.style.display='none';
  }
  if(finStatusFilter) rows = rows.filter(r=>r.status===finStatusFilter);
  count.textContent = rows.length+' shown';
  const statusLabel = finStatusFilter ? (' · '+finStatusFilter) : '';
  title.textContent = 'Invoices — '+titleBase+statusLabel;
  body.innerHTML = rows.length ? rows.map(r=>
    `<tr class="row-click" onclick="openS360('${r.vendor}')"><td>${r.inv}</td><td><span class="vendor-link">${r.vendor}</span></td><td>${r.amt}</td><td>${r.due}</td><td>${r.days||'—'}</td><td>${pillFor(r.status)}</td></tr>`
  ).join('') : '<tr class="empty-row"><td colspan="6">No invoices match this filter</td></tr>';
}
 function finUpdateMonth(month){
  finMonthFilter = month; finStatusFilter = null; finExtraFilter = null;
  clearActiveHighlights();
  document.getElementById('finCategory').chart.data.datasets[0].data = finCatByMonth[month];
  document.getElementById('finCategory').chart.update();
  document.getElementById('finCategoryTitle').textContent = 'Spend by category — '+month;
  const k = finKpiByMonth[month];
  document.getElementById('finKpiSpend').textContent = k.spend;
  document.getElementById('finKpiOverdue').textContent = k.overdue;
  document.getElementById('finKpiSavings').textContent = k.savings;
  document.getElementById('finKpiBudget').textContent = k.budget;
  renderFinInvoices();
}
function finReset(){ finUpdateMonth('Aug'); }
function finClearExtraFilter(){ finExtraFilter=null; clearActiveHighlights(); renderFinInvoices(); }

function finPayablesClick(bucket, el){
  finExtraFilter = {type:'payables', value:bucket, label:'Outstanding payables: '+payablesBucketLabel[bucket]};
  finStatusFilter = null; clearActiveHighlights(); el?.classList?.add('active'); renderFinInvoices();
}
function finWindowClick(days, el){
  finExtraFilter = {type:'window', value:days, label:'Due within '+days+' days'};
  finStatusFilter = null; clearActiveHighlights(); el.classList.add('active'); renderFinInvoices();
}
function finExceptionClick(type, el){
  finExtraFilter = {type:'exception', value:type, label:'Exception: '+exceptionLabel[type]};
  finStatusFilter = null; clearActiveHighlights(); el.classList.add('active'); renderFinInvoices();
}
function finAgingClick(bucket){
  finExtraFilter = {type:'aging', value:bucket, label:'Accounts Payable Aging: '+agingBucketLabel[bucket]};
  finStatusFilter = null; clearActiveHighlights(); renderFinInvoices();
}

const finSpendChart = createChart('finSpendChart', {
  data:{labels:finMonths, datasets:[
    {type:'bar', label:'Actual spend', data:[62,68,71,76,80,79,83,84], backgroundColor:'#2A5FD9', borderRadius:4, maxBarThickness:22},
    {type:'line', label:'Budget', data:[65,65,70,75,78,80,82,85], borderColor:'#C3C6DA', borderWidth:2, pointRadius:0, tension:.3}
  ]},
  options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}}, scales:{x:baseGrid(), y:baseGrid()},
    onClick:(evt,els)=>{ if(els.length) finUpdateMonth(finMonths[els[0].index]); }
  }
});

const finCategoryChart = createChart('finCategory', {
  type:'bar', data:{labels:finCatLabels, datasets:[{data:finCatByMonth.Aug, backgroundColor:'#2A5FD9', borderRadius:4, maxBarThickness:18}]},
  options:{indexAxis:'y', responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}},
    scales:{x:baseGrid(), y:{grid:{display:false},border:{display:false},ticks:{color:muted}}}}
});
if(document.getElementById('finCategory')) document.getElementById('finCategory').chart = finCategoryChart;

const finPayStatusChart = createChart('finPayStatus', {
  type:'doughnut', data:{labels:['Paid','Pending','Overdue'], datasets:[{data:[68,22,10], backgroundColor:['#0F9E7A','#C9781C','#D14343'], borderWidth:3, borderColor:'#fff'}]},
  options:{responsive:true, maintainAspectRatio:false, cutout:'70%', plugins:{legend:{display:false}},
    onClick:(evt,els)=>{ if(els.length){ const statuses=['paid','pending','overdue']; finExtraFilter=null; clearActiveHighlights(); finStatusFilter = statuses[els[0].index]; renderFinInvoices(); } }
  }
});

createChart('finTopVendors', {
  type:'bar', data:{labels:['AHB Pharma','XYZ Chemicals','MediLife Ltd','HealthCorp','BioGen'],
    datasets:[{data:[18.4,15.1,12.7,9.3,7.6], backgroundColor:'#7A4DE0', borderRadius:4, maxBarThickness:16}]},
  options:{indexAxis:'y', responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}},
    scales:{x:baseGrid(), y:{grid:{display:false}, border:{display:false}, ticks:{color:muted}}},
    onClick:(evt,els)=>{ if(els.length){ const names=['AHB Pharma','XYZ Chemicals','MediLife Ltd','HealthCorp','BioGen']; openS360(names[els[0].index]); } }
  }
});

// AP aging chart — amounts (₹L) of currently outstanding invoices by age bucket, sums to the ₹13.03L outstanding total
createChart('finAgingChart', {
  type:'bar', data:{labels:['Current','1-30','31-60','61-90','90+'],
    datasets:[{data:[5.79,4.90,0.74,0.44,1.16], backgroundColor:['#2A5FD9','#C9781C','#D97757','#D14343','#8C1F1F'], borderRadius:4, maxBarThickness:34}]},
  options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}}, scales:{x:baseGrid(), y:baseGrid()},
    onClick:(evt,els)=>{ if(els.length){ const buckets=['current','1-30','31-60','61-90','90+']; finAgingClick(buckets[els[0].index]); } }
  }
});

renderFinInvoices();

/* ============ MANAGEMENT DATA + INTERACTIONS ============ */
const mgmtYears=['2021','2022','2023','2024','2025','2026'];
const mgmtMixByYear={
  '2021':[28,24,20,16,12], '2022':[29,25,20,15,11], '2023':[30,25,19,15,11],
  '2024':[31,26,19,14,10], '2025':[33,26,18,13,10], '2026':[34,26,18,12,10]
};
const mgmtCatLabels=['Medicine','Raw material','Equipment','Packaging','Logistics'];
const mgmtCatColors=['#2A5FD9','#7A4DE0','#0F9E7A','#C9781C','#D14343'];
// Total procurement spend by year (₹ Lakh) — 2026 total matches the ₹6.03 Cr KPI
const mgmtTotalSpendByYearL={'2021':210,'2022':285,'2023':362,'2024':448,'2025':528,'2026':603};
// Vendor count by year, reused as a growth ratio to scale material quantity across years
const mgmtVendorGrowth={'2021':40,'2022':52,'2023':63,'2024':74,'2025':98,'2026':120};
// Base material quantity per category for 2026 (units)
const mgmtQtyBase2026=[18400,42200,620,35100,1200];
window.mgmtQtyForYear = function mgmtQtyForYear(year){
  const ratio = mgmtVendorGrowth[year]/mgmtVendorGrowth['2026'];
  return mgmtQtyBase2026.map(q=>Math.round(q*ratio));
}
window.mgmtExpenseForYear = function mgmtExpenseForYear(year){
  const total = mgmtTotalSpendByYearL[year];
  return mgmtMixByYear[year].map(pct=>+(total*pct/100).toFixed(1));
}
let mgmtYearFilter=null;

function mgmtUpdateYear(year){
  mgmtYearFilter = year;
  document.getElementById('mgmtCategoryMix').chart.data.datasets[0].data = mgmtQtyForYear(year);
  document.getElementById('mgmtCategoryMix').chart.update();
  document.getElementById('mgmtMixTitle').textContent = 'Category mix — '+year;
  document.getElementById('mgmtGrowthTitle').textContent = 'Vendor growth — '+year+' selected';
}
function mgmtReset(){
  mgmtYearFilter=null;
  document.getElementById('mgmtCategoryMix').chart.data.datasets[0].data = mgmtQtyForYear('2026');
  document.getElementById('mgmtCategoryMix').chart.update();
  document.getElementById('mgmtMixTitle').textContent = 'Category mix — all years';
  document.getElementById('mgmtGrowthTitle').textContent = 'Vendor growth';
}
function mgmtFlashCategoryMix(){
  const card = document.getElementById('mgmtMixCard');
  card.style.transition='box-shadow .2s, border-color .2s';
  card.style.borderColor='#2A5FD9';
  card.style.boxShadow='0 0 0 3px rgba(42,95,217,0.15)';
  card.scrollIntoView({behavior:'smooth', block:'center'});
  setTimeout(()=>{ card.style.borderColor=''; card.style.boxShadow=''; }, 1400);
}

createChart('mgmtGrowth', {
  type:'bar', data:{labels:mgmtYears, datasets:[{data:[40,52,63,74,98,120], backgroundColor:'#7A4DE0', borderRadius:5, maxBarThickness:34}]},
  options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}}, scales:{x:baseGrid(), y:baseGrid()},
    onClick:(evt,els)=>{ if(els.length) mgmtUpdateYear(mgmtYears[els[0].index]); }
  }
});

const mgmtMixChart = createChart('mgmtCategoryMix', {
  type:'bar',
  data:{labels:mgmtCatLabels, datasets:[{data:mgmtQtyForYear('2026'), backgroundColor:mgmtCatColors, borderRadius:4, maxBarThickness:24}]},
  options:{indexAxis:'y', responsive:true, maintainAspectRatio:false,
    plugins:{legend:{display:false},
      tooltip:{callbacks:{
        label:(ctx)=>{
          const year = mgmtYearFilter||'2026';
          const exp = mgmtExpenseForYear(year)[ctx.dataIndex];
          return ['Quantity: '+ctx.raw.toLocaleString()+' units', 'Expense: ₹'+exp+'L'];
        }
      }}
    },
    scales:{
      x:{...baseGrid(), title:{display:true, text:'Material quantity (units)', color:muted, font:{size:10.5}}},
      y:{grid:{display:false}, border:{display:false}, ticks:{color:muted}}
    }
  }
});
if(document.getElementById('mgmtCategoryMix')) document.getElementById('mgmtCategoryMix').chart = mgmtMixChart;

// Procurement savings (₹L): Negotiated 182, Realized 135, Pending 47 → realization = 135/182 = 74.2%
const mgmtSavingsDetails = {
  negotiated:'Largest negotiated contracts: BioGen ₹38L, HealthCorp ₹34L, Vedica Store ₹22L.',
  realized:'Top contributors to realized savings: AHB Pharma ₹42L, XYZ Chemicals ₹31L, MediLife Ltd ₹24L.',
  pending:'3 vendor contracts awaiting final sign-off before savings can be realized (₹47L).'
};
createChart('mgmtSavingsChart', {
  type:'bar', data:{labels:['Negotiated','Realized','Pending'],
    datasets:[{data:[182,135,47], backgroundColor:['#2A5FD9','#0F9E7A','#C9781C'], borderRadius:4, maxBarThickness:26}]},
  options:{indexAxis:'y', responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}},
    scales:{x:baseGrid(), y:{grid:{display:false}, border:{display:false}, ticks:{color:muted}}},
    onClick:(evt,els)=>{ if(els.length){
      const keys=['negotiated','realized','pending'];
      const box=document.getElementById('mgmtSavingsDetail');
      box.textContent = mgmtSavingsDetails[keys[els[0].index]];
      box.style.display='block';
    }}
  }
});

// Supplier concentration — top 5 vendors as % of total YTD spend (₹6.03 Cr); sums to the 63% Top-5 callout
createChart('mgmtConcentrationChart', {
  type:'bar', data:{labels:['AHB Pharma','XYZ Chemicals','MediLife Ltd','HealthCorp','BioGen'],
    datasets:[{data:[22,15,12,8,6], backgroundColor:'#7A4DE0', borderRadius:4, maxBarThickness:20}]},
  options:{indexAxis:'y', responsive:true, maintainAspectRatio:false,
    plugins:{legend:{display:false}, tooltip:{callbacks:{label:(ctx)=>ctx.raw+'% of total spend'}}},
    scales:{x:{...baseGrid(), max:25}, y:{grid:{display:false}, border:{display:false}, ticks:{color:muted}}},
    onClick:(evt,els)=>{ if(els.length){ const names=['AHB Pharma','XYZ Chemicals','MediLife Ltd','HealthCorp','BioGen']; openS360(names[els[0].index]); } }
  }
});

// Shared KPI detail panel — Avg vendor score breakdown / Supplier OTIF trend / Risk exposure by severity
let mgmtDetailChart=null;
const mgmtOtifTrend={labels:["Q3'24","Q4'24","Q1'25","Q2'25","Q3'25","Q4'25"], data:[80.5,82.1,83.6,84.8,85.3,87.4]};
window.mgmtShowDetail = function mgmtShowDetail(type){
  const panel=document.getElementById('mgmtDetailPanel');
  const title=document.getElementById('mgmtDetailTitle');
  const body=document.getElementById('mgmtDetailBody');
  panel.style.display='block';

  if(type==='score'){
    title.textContent='Vendor score breakdown (weighted avg = 82/100)';
    body.innerHTML = `<div class="funnel">
      <div class="funnel-row"><div class="funnel-label">Delivery</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:86%;background:#2A5FD9;">86</div></div></div>
      <div class="funnel-row"><div class="funnel-label">Quality</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:79%;background:#7A4DE0;">79</div></div></div>
      <div class="funnel-row"><div class="funnel-label">Compliance</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:88%;background:#0F9E7A;">88</div></div></div>
      <div class="funnel-row"><div class="funnel-label">Price</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:71%;background:#C9781C;">71</div></div></div>
      <div class="funnel-row"><div class="funnel-label">PO fulfilment</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:86%;background:#D14343;">86</div></div></div>
    </div>`;
  } else if(type==='otif'){
    title.textContent='Supplier OTIF — trailing 6 quarters';
    body.innerHTML = `<div class="chart-wrap" style="height:180px;"><canvas id="mgmtDetailChart"></canvas></div>`;
    if(mgmtDetailChart){ mgmtDetailChart.destroy(); mgmtDetailChart=null; }
    setTimeout(()=>{
      mgmtDetailChart = createChart('mgmtDetailChart', {
        type:'line', data:{labels:mgmtOtifTrend.labels, datasets:[{data:mgmtOtifTrend.data, borderColor:'#7A4DE0', backgroundColor:'rgba(122,77,224,0.08)', fill:true, tension:.35, pointRadius:3, borderWidth:2}]},
        options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}}, scales:{x:baseGrid(), y:{...baseGrid(), min:75, max:92}}}
      });
    }, 30);
  } else if(type==='risk'){
    title.textContent='Supplier risk exposure by severity';
    body.innerHTML = `<table><tr><th>Severity</th><th>Alerts</th><th>₹ exposure</th><th></th></tr>
      <tr class="row-click" onclick="openS360('XYZ Chemicals')"><td><span class="pill red">High</span></td><td>3</td><td>₹1.12 Cr</td><td><span class="vendor-link">XYZ Chemicals →</span></td></tr>
      <tr class="row-click" onclick="openS360('HealthCorp')"><td><span class="pill amber">Medium</span></td><td>5</td><td>₹58L</td><td><span class="vendor-link">HealthCorp →</span></td></tr>
      <tr class="row-click" onclick="openS360('Vedica Store')"><td><span class="pill blue">Low</span></td><td>2</td><td>₹16L</td><td><span class="vendor-link">Vedica Store →</span></td></tr>
    </table>`;
  }
  panel.scrollIntoView({behavior:'smooth', block:'nearest'});
}
function mgmtCloseDetail(){ document.getElementById('mgmtDetailPanel').style.display='none'; }

/* ============ OPERATIONS DATA + INTERACTIONS ============ */
const opsMonths=['Sep','Oct','Nov','Dec','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug'];
const opsCatByMonth={
  Sep:[38,30,20,12], Oct:[37,29,21,13], Nov:[36,28,22,14], Dec:[35,28,23,14],
  Jan:[35,27,23,15], Feb:[36,27,22,15], Mar:[36,27,22,15], Apr:[35,27,23,15],
  May:[35,27,23,15], Jun:[35,28,22,15], Jul:[35,27,23,15], Aug:[36,27,22,15]
};
const opsCatLabels=['Carmozyme','Analgesic','Antibiotic','Ayurvedic'];
const opsCatPrices=[2500,900,1400,650]; // ₹ per unit, used to derive value from the 657-unit current stock baseline
const opsCatColors=['#2A5FD9','#7A4DE0','#0F9E7A','#C9781C'];

// Per-category coverage (days) and stockout counts — weighted avg reconciles to the 21.6-day / 8-item KPIs
const opsCategoryStats = {
  Carmozyme:{coverage:14.2, critical:2, low:1},
  Analgesic:{coverage:26.8, critical:0, low:1},
  Antibiotic:{coverage:19.5, critical:1, low:2},
  Ayurvedic:{coverage:33.1, critical:0, low:1}
};

// Every outstanding reorder/stockout-risk item, keyed by month; Aug carries the full 8-item snapshot behind the KPI cards
const opsReorderByMonth={
  Aug:[
    {item:'Carmozyme 250mg', category:'Carmozyme', cur:18, daysRemaining:4, incoming:0, qty:200, vendor:'AHB Pharma', risk:'critical'},
    {item:'Carmozyme 500mg', category:'Carmozyme', cur:9, daysRemaining:2, incoming:50, qty:150, vendor:'AHB Pharma', risk:'critical'},
    {item:'Carmozyme Syrup', category:'Carmozyme', cur:34, daysRemaining:11, incoming:0, qty:100, vendor:'AHB Pharma', risk:'low'},
    {item:'Analgesic Syrup', category:'Analgesic', cur:32, daysRemaining:9, incoming:0, qty:150, vendor:'MediLife Ltd', risk:'low'},
    {item:'Antibiotic Cap 500', category:'Antibiotic', cur:11, daysRemaining:3, incoming:0, qty:220, vendor:'XYZ Chemicals', risk:'critical'},
    {item:'Antibiotic Cap 250', category:'Antibiotic', cur:27, daysRemaining:8, incoming:100, qty:180, vendor:'XYZ Chemicals', risk:'low'},
    {item:'Antibiotic Syrup', category:'Antibiotic', cur:30, daysRemaining:10, incoming:0, qty:120, vendor:'XYZ Chemicals', risk:'low'},
    {item:'Ayurvedic Tonic', category:'Ayurvedic', cur:22, daysRemaining:12, incoming:0, qty:120, vendor:'HealthCorp', risk:'low'}
  ],
  Jul:[
    {item:'Ayurvedic Tonic', category:'Ayurvedic', cur:22, daysRemaining:14, incoming:0, qty:120, vendor:'HealthCorp', risk:'low'},
    {item:'Carmozyme 250mg', category:'Carmozyme', cur:40, daysRemaining:16, incoming:0, qty:100, vendor:'AHB Pharma', risk:'low'}
  ],
  Jun:[
    {item:'Analgesic Syrup', category:'Analgesic', cur:15, daysRemaining:5, incoming:0, qty:180, vendor:'MediLife Ltd', risk:'critical'}
  ]
};
let opsMonthFilter='Aug', opsCategoryFilter=null, opsRiskOnly=false, opsCatMode='value';

function opsRiskPillFor(r){ return r==='critical' ? '<span class="pill red">Critical</span>' : '<span class="pill amber">At risk</span>'; }

function opsCategoryData(month){
  const pct = opsCatByMonth[month];
  const units = pct.map(p=>Math.round(657*p/100));
  const value = units.map((u,i)=>+(u*opsCatPrices[i]/100000).toFixed(2));
  return {labels:opsCatLabels, pct, units, value};
}

function opsUpdateFilterBar(){
  const bar=document.getElementById('opsFilterBar');
  const chips=document.getElementById('opsFilterChips');
  const parts=[];
  if(opsMonthFilter!=='Aug') parts.push(['Month: '+opsMonthFilter, ()=>opsUpdateMonth('Aug')]);
  if(opsCategoryFilter) parts.push(['Category: '+opsCategoryFilter, ()=>opsCategoryClick(opsCategoryFilter)]);
  if(opsRiskOnly) parts.push(['All stockout-risk items', ()=>{ opsRiskOnly=false; renderOpsReorder(); opsUpdateFilterBar(); }]);
  if(!parts.length){ bar.style.display='none'; return; }
  bar.style.display='flex';
  chips.innerHTML = parts.map((p,i)=>`<span class="active-filter-tag">${p[0]} <span class="x" onclick="opsFilterChipClear(${i})">✕</span></span>`).join('');
  window._opsChipActions = parts.map(p=>p[1]);
}
function opsFilterChipClear(i){ if(window._opsChipActions && window._opsChipActions[i]) window._opsChipActions[i](); opsUpdateFilterBar(); }

function renderOpsReorder(){
  const count=document.getElementById('opsReorderCount');
  const title=document.getElementById('opsReorderTitle');
  const body=document.getElementById('opsReorderBody');
  if(!count || !title || !body) return;

  let rows, titleBase;
  if(opsRiskOnly){
    rows = opsReorderByMonth.Aug.slice();
    titleBase = 'All stockout-risk items';
  } else {
    rows = (opsReorderByMonth[opsMonthFilter] || []).slice();
    titleBase = opsMonthFilter;
  }
  if(opsCategoryFilter) rows = rows.filter(r=>r.category===opsCategoryFilter);
  count.textContent = rows.length+' shown';
  title.textContent = 'Reorder & stockout risk — '+titleBase+(opsCategoryFilter?(' · '+opsCategoryFilter):'');
  body.innerHTML = rows.length ? rows.map(r=>
    `<tr class="row-click" onclick="openS360('${r.vendor}')"><td>${r.item}</td><td>${r.category}</td><td>${r.cur}</td><td>${r.daysRemaining}d</td><td>${r.incoming||'—'}</td><td>${r.qty}</td><td><span class="vendor-link">${r.vendor}</span></td><td>${opsRiskPillFor(r.risk)}</td></tr>`
  ).join('') : '<tr class="empty-row"><td colspan="8">No items match this filter</td></tr>';
}

function opsRenderCategoryChart(){
  const categoryCanvas=document.getElementById('opsCategoryChart');
  if(!categoryCanvas?.chart) return;

  const d = opsCategoryData(opsMonthFilter);
  const chart = categoryCanvas.chart;
  let data, axisLabel;
  if(opsCatMode==='value'){ data=d.value; axisLabel='₹ Lakh'; }
  else if(opsCatMode==='units'){ data=d.units; axisLabel='Units'; }
  else { data=d.pct; axisLabel='%'; }
  chart.data.datasets[0].data = data;
  chart.data.datasets[0].backgroundColor = opsCatColors.map((c,i)=> !opsCategoryFilter || opsCatLabels[i]===opsCategoryFilter ? c : '#D9DBE8');
  chart.update();
  document.getElementById('opsCatTitle').textContent = 'Inventory '+(opsCatMode==='pct'?'share':opsCatMode==='units'?'units':'value')+' by category'+(opsMonthFilter!=='Aug' ? ' — '+opsMonthFilter : '');
}
function opsSetCatMode(mode, el){
  opsCatMode = mode;
  document.querySelectorAll('#page-ops .scenario-btn').forEach(b=>b.classList.remove('active'));
  el.classList.add('active');
  opsRenderCategoryChart();
}
window.opsCategoryClick = function opsCategoryClick(cat){
  opsCategoryFilter = (opsCategoryFilter===cat) ? null : cat;
  const stats = opsCategoryStats[cat];
  if(opsCategoryFilter && stats){
    document.getElementById('opsKpiCoverage').textContent = stats.coverage+' days';
    document.getElementById('opsKpiCoverageSub').textContent = cat+' only';
    const total = stats.critical+stats.low;
    document.getElementById('opsKpiStockout').textContent = total+' at-risk';
    document.getElementById('opsKpiStockoutSub').textContent = stats.critical+' critical · '+stats.low+' at-risk · '+cat;
  } else {
    document.getElementById('opsKpiCoverage').textContent = '21.6 days';
    document.getElementById('opsKpiCoverageSub').textContent = '▼ 3.6d vs last month';
    document.getElementById('opsKpiStockout').textContent = '8 at-risk';
    document.getElementById('opsKpiStockoutSub').textContent = '3 critical · 5 at-risk · view list';
  }
  opsRenderCategoryChart();
  renderOpsReorder();
  opsUpdateFilterBar();
}

window.opsUpdateMonth = function opsUpdateMonth(month){
  opsMonthFilter = month;
  opsRiskOnly = false;
  opsRenderCategoryChart();
  document.getElementById('opsMoveTitle').textContent = month==='Aug' ? 'Stock movement trend' : 'Stock movement trend — '+month+' selected';
  renderOpsReorder();
  opsUpdateFilterBar();
}
window.opsReset = function opsReset(){ opsCategoryFilter=null; opsUpdateMonth('Aug'); }
window.opsResetAll = function opsResetAll(){ opsCategoryFilter=null; opsRiskOnly=false; opsUpdateMonth('Aug'); opsCloseDetail(); }
window.opsShowRiskAll = function opsShowRiskAll(){ opsRiskOnly=true; renderOpsReorder(); opsUpdateFilterBar();
  const card=document.getElementById('opsReorderBody').closest('.card');
  card.scrollIntoView({behavior:'smooth', block:'center'});
  card.style.transition='box-shadow .2s, border-color .2s'; card.style.borderColor='#D14343'; card.style.boxShadow='0 0 0 3px rgba(209,67,67,0.15)';
  setTimeout(()=>{ card.style.borderColor=''; card.style.boxShadow=''; }, 1400);
}

// Shared detail panel — fulfilment-stage orders / vendor delayed POs / slow-moving stock buckets
const opsFunnelOrders = {
  packed:[{po:'PO1023',item:'Carmozyme 250mg',qty:200,vendor:'AHB Pharma',date:'22 Aug'},{po:'PO1067',item:'Antibiotic Cap 500',qty:180,vendor:'XYZ Chemicals',date:'23 Aug'},{po:'PO1071',item:'Ayurvedic Tonic',qty:120,vendor:'HealthCorp',date:'24 Aug'}],
  shipped:[{po:'PO1019',item:'Analgesic Syrup',qty:150,vendor:'MediLife Ltd',date:'20 Aug'},{po:'PO1044',item:'Carmozyme Syrup',qty:100,vendor:'AHB Pharma',date:'21 Aug'},{po:'PO1072',item:'Analgesic Syrup',qty:90,vendor:'BioGen',date:'20 Aug'}],
  delivered:[{po:'PO1002',item:'Ayurvedic Tonic',qty:90,vendor:'HealthCorp',date:'18 Aug'},{po:'PO1005',item:'Antibiotic Cap 250',qty:140,vendor:'XYZ Chemicals',date:'19 Aug'}],
  done:[{po:'PO1011',item:'Antibiotic Cap 500',qty:300,vendor:'XYZ Chemicals',date:'10 Aug'},{po:'PO0987',item:'Analgesic Syrup',qty:200,vendor:'HealthCorp',date:'08 Aug'}]
};
const opsFunnelLabel={packed:'To be packed', shipped:'To be shipped', delivered:'To be delivered', done:'Delivered'};

const opsVendorDelays = {
  'BioGen':{avg:4.8, pos:[{po:'PO1072',item:'Analgesic Syrup',expected:'15 Aug',late:5,status:'In transit'}]},
  'XYZ Chemicals':{avg:3.1, pos:[{po:'PO1067',item:'Antibiotic Cap 500',expected:'20 Aug',late:3,status:'Pending'}]},
  'HealthCorp':{avg:2.4, pos:[{po:'PO1071',item:'Ayurvedic Tonic',expected:'21 Aug',late:2,status:'Pending'}]},
  'MediLife Ltd':{avg:1.2, pos:[]},
  'AHB Pharma':{avg:0.6, pos:[]},
  'Vedica Store':{avg:0.3, pos:[]}
};

const opsSlowBuckets = {
  '0-30':{value:4.4, detail:'Recently restocked — Carmozyme 250mg ₹1.2L, Antibiotic Cap 500 ₹0.9L, others ₹2.3L. Healthy turnover, no action needed.'},
  '31-90':{value:3.1, detail:'Analgesic Syrup ₹1.1L, Ayurvedic Tonic ₹0.8L, others ₹1.2L. Within normal range — monitor.'},
  '91-180':{value:1.8, detail:'Antibiotic Syrup ₹0.7L (142 days), Carmozyme Syrup ₹0.6L (128 days), others ₹0.5L. Consider a promotional push to clear these.'},
  '180+':{value:0.9, detail:'Ayurvedic Tonic (old batch) ₹0.32L (210 days), Antibiotic Cap 250 ₹0.28L (195 days), others ₹0.30L. Recommend write-off review.'}
};

window.opsShowDetail = function opsShowDetail(type, key){
  const panel=document.getElementById('opsDetailPanel');
  const title=document.getElementById('opsDetailTitle');
  const body=document.getElementById('opsDetailBody');
  panel.style.display='block';

  if(type==='funnel'){
    title.textContent = 'Orders — '+opsFunnelLabel[key]+' ('+(opsFunnelOrders[key]||[]).length+' shown)';
    const rows = opsFunnelOrders[key]||[];
    body.innerHTML = `<table><tr><th>PO number</th><th>Item</th><th>Qty</th><th>Vendor</th><th>Expected</th></tr>` +
      (rows.length ? rows.map(r=>`<tr class="row-click" onclick="openS360('${r.vendor}')"><td>${r.po}</td><td>${r.item}</td><td>${r.qty}</td><td><span class="vendor-link">${r.vendor}</span></td><td>${r.date}</td></tr>`).join('') : '<tr class="empty-row"><td colspan="5">No orders at this stage</td></tr>') + `</table>`;
  } else if(type==='vendor'){
    const v = opsVendorDelays[key];
    title.textContent = key+' — delayed deliveries (avg '+v.avg+'d delay)';
    body.innerHTML = v.pos.length ? `<table><tr><th>PO number</th><th>Item</th><th>Expected</th><th>Days late</th><th>Status</th></tr>` +
      v.pos.map(r=>`<tr><td>${r.po}</td><td>${r.item}</td><td>${r.expected}</td><td>${r.late}</td><td><span class="pill amber">${r.status}</span></td></tr>`).join('') + `</table>`
      : `<p style="font-size:12.5px;color:var(--text-sec);">No significant delays currently for ${key}.</p>`;
  } else if(type==='slow'){
    const b = opsSlowBuckets[key];
    title.textContent = 'Slow-moving stock — '+key+' days (₹'+b.value+'L)';
    body.innerHTML = `<p style="font-size:12.5px;color:var(--text-sec);line-height:1.6;">${b.detail}</p>`;
  }
  panel.scrollIntoView({behavior:'smooth', block:'nearest'});
}
window.opsCloseDetail = function opsCloseDetail(){ document.getElementById('opsDetailPanel').style.display='none'; }
window.opsFunnelClick = function opsFunnelClick(stage){
  document.querySelectorAll('#opsFunnel .funnel-row').forEach(r=>r.style.background='');
  const row = document.querySelector('#opsFunnel .funnel-row[data-stage="'+stage+'"]');
  row.style.background = 'var(--bg)'; row.style.borderRadius='8px';
  opsShowDetail('funnel', stage);
}

createChart('opsMovement', {
  type:'line', data:{labels:opsMonths, datasets:[
    {label:'Stock in', data:[40,45,38,52,48,60,55,63,58,49,61,23], borderColor:'#0F9E7A', backgroundColor:'rgba(15,158,122,0.08)', fill:true, tension:.35, pointRadius:3, borderWidth:2, yAxisID:'y'},
    {label:'Stock out', data:[30,34,40,38,44,41,50,47,52,55,48,35], borderColor:'#D14343', backgroundColor:'rgba(209,67,67,0.06)', fill:true, tension:.35, pointRadius:3, borderWidth:2, yAxisID:'y'}
  ]},
  options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}},
    scales:{x:baseGrid(), y:{...baseGrid(), position:'left'}},
    onClick:(evt,els)=>{ if(els.length) opsUpdateMonth(opsMonths[els[0].index]); }
  }
});

const opsCategoryChart = createChart('opsCategoryChart', {
  type:'bar', data:{labels:opsCatLabels, datasets:[{data:opsCategoryData('Aug').value, backgroundColor:opsCatColors, borderRadius:4, maxBarThickness:26}]},
  options:{indexAxis:'y', responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}},
    scales:{x:baseGrid(), y:{grid:{display:false}, border:{display:false}, ticks:{color:muted}}},
    onClick:(evt,els)=>{ if(els.length) opsCategoryClick(opsCatLabels[els[0].index]); }
  }
});
if(document.getElementById('opsCategoryChart')) document.getElementById('opsCategoryChart').chart = opsCategoryChart;

createChart('opsDelayChart', {
  type:'bar', data:{labels:['BioGen','XYZ Chemicals','HealthCorp','MediLife Ltd','AHB Pharma','Vedica Store'],
    datasets:[{data:[4.8,3.1,2.4,1.2,0.6,0.3], backgroundColor:['#D14343','#D97757','#C9781C','#C9781C','#0F9E7A','#0F9E7A'], borderRadius:4, maxBarThickness:16}]},
  options:{indexAxis:'y', responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false},
    tooltip:{callbacks:{label:(ctx)=>ctx.raw+' days avg delay'}}},
    scales:{x:baseGrid(), y:{grid:{display:false}, border:{display:false}, ticks:{color:muted}}},
    onClick:(evt,els)=>{ if(els.length){ const names=['BioGen','XYZ Chemicals','HealthCorp','MediLife Ltd','AHB Pharma','Vedica Store']; opsShowDetail('vendor', names[els[0].index]); } }
  }
});

createChart('opsSlowChart', {
  type:'bar', data:{labels:['0-30','31-90','91-180','180+'],
    datasets:[{data:[4.4,3.1,1.8,0.9], backgroundColor:['#0F9E7A','#2A5FD9','#C9781C','#D14343'], borderRadius:4, maxBarThickness:40}]},
  options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}}, scales:{x:baseGrid(), y:baseGrid()},
    onClick:(evt,els)=>{ if(els.length){ const buckets=['0-30','31-90','91-180','180+']; opsShowDetail('slow', buckets[els[0].index]); } }
  }
});

renderOpsReorder();

/* ============ VENDOR DATA + INTERACTIONS ============ */
let vendPOs=[
  {po:'PO1023',item:'Carmozyme 250mg',qty:200,delivery:'22 Aug 2026',status:'pending',month:'Aug'},
  {po:'PO1032',item:'Ayurvedic Tonic',qty:80,delivery:'28 Aug 2026',status:'pending',month:'Aug'},
  {po:'PO1019',item:'Analgesic Syrup',qty:150,delivery:'20 Aug 2026',status:'transit',month:'Aug'},
  {po:'PO1011',item:'Antibiotic Cap 500',qty:300,delivery:'10 Aug 2026',status:'delivered',month:'Aug'},
  {po:'PO1002',item:'Ayurvedic Tonic',qty:90,delivery:'02 Aug 2026',status:'delivered',month:'Aug'},
  {po:'PO0996',item:'Carmozyme 250mg',qty:120,delivery:'26 Jul 2026',status:'cancelled',month:'Jul'},
  {po:'PO0940',item:'Antibiotic Cap 500',qty:140,delivery:'18 May 2026',status:'delivered',month:'May'},
  {po:'PO0910',item:'Analgesic Syrup',qty:90,delivery:'25 Mar 2026',status:'delivered',month:'Mar'},
];
let vendInvoices=[
  {inv:'INV-4010',amt:'₹52,000',stage:'submitted',date:'10 Aug 2026'},
  {inv:'INV-4009',amt:'₹38,500',stage:'review',date:'05 Aug 2026'},
  {inv:'INV-4008',amt:'₹61,800',stage:'approved',date:'12 Aug 2026'},
  {inv:'INV-3021',amt:'₹1,45,000',stage:'payment-due',date:'02 Aug 2026',overdueDays:16},
  {inv:'INV-4007',amt:'₹29,400',stage:'payment-due',date:'25 Aug 2026'},
  {inv:'INV-4006',amt:'₹98,000',stage:'paid',date:'15 Jul 2026'},
  {inv:'INV-4005',amt:'₹22,000',stage:'rejected',date:'14 Aug 2026',reason:'Quantity mismatch with PO0996'},
];
let vendDocs = {
  'iso9001':{name:'ISO 9001 certification', status:'Expires in 18 days', detail:'Your ISO 9001:2015 certification expires on 05 Sep 2026. Upload a renewed certificate to avoid disruption to new purchase orders.'},
  'trade-license':{name:'Trade license renewal', status:'Missing', detail:'Your trade license document is missing from our records. Please upload a valid copy to remain compliant.'}
};
const vendStageLabel={submitted:'Submitted', review:'Under review', approved:'Approved', 'payment-due':'Payment due', paid:'Paid', rejected:'Rejected'};
let vendDelayedShipment={po:'PO0978', item:'Antibiotic Cap 500', expected:'12 Jul 2026', delivered:'15 Jul 2026', lateDays:3};
const vendFeedbackByMonth={
  Mar:'Feedback: Consistent quality, no issues logged.',
  May:'Feedback: On-time delivery improved from prior quarter.',
  Jul:'Feedback: One shipment delayed by 3 days (PO0978).',
  Aug:'Feedback: Strong on-time performance, minor packaging note on PO1002.'
};

// Per-vendor datasets that power the vendor switcher. AHB Pharma reuses the base arrays above.
const vendorVMSData={
  'AHB Pharma':{pos:vendPOs, invoices:vendInvoices, docs:vendDocs, delayedShipment:vendDelayedShipment, feedback:vendFeedbackByMonth.Aug, dueThisWeek:2},
  'XYZ Chemicals':{
    pos:[
      {po:'PO1067',item:'Industrial Solvent',qty:500,delivery:'24 Aug 2026',status:'pending',month:'Aug'},
      {po:'PO1055',item:'Chemical Compound X12',qty:300,delivery:'19 Aug 2026',status:'transit',month:'Aug'},
      {po:'PO1041',item:'Industrial Solvent',qty:450,delivery:'08 Aug 2026',status:'delivered',month:'Aug'},
      {po:'PO0987',item:'Chemical Compound X12',qty:280,delivery:'22 Jul 2026',status:'delivered',month:'Jul'},
      {po:'PO0955',item:'Industrial Solvent',qty:400,delivery:'12 Jun 2026',status:'cancelled',month:'Jun'}
    ],
    invoices:[
      {inv:'INV-5102',amt:'₹1,10,000',stage:'submitted',date:'11 Aug 2026'},
      {inv:'INV-5098',amt:'₹64,000',stage:'review',date:'06 Aug 2026'},
      {inv:'INV-5090',amt:'₹88,500',stage:'payment-due',date:'01 Aug 2026',overdueDays:12},
      {inv:'INV-5081',amt:'₹42,300',stage:'rejected',date:'15 Aug 2026',reason:'Price mismatch with PO0955'},
      {inv:'INV-5070',amt:'₹95,000',stage:'paid',date:'10 Jul 2026'}
    ],
    docs:{'trade-license':{name:'Trade license renewal', status:'Expires in 9 days', detail:'Your trade license expires on 27 Aug 2026. Upload a renewed copy to avoid disruption to new purchase orders.'}},
    delayedShipment:{po:'PO0940', item:'Industrial Solvent', expected:'02 Jun 2026', delivered:'07 Jun 2026', lateDays:5},
    feedback:'Feedback: Delivery delays observed on 2 shipments this quarter.', dueThisWeek:1
  },
  'MediLife Ltd':{
    pos:[
      {po:'PO1104',item:'Diagnostic Scanner Unit',qty:2,delivery:'25 Aug 2026',status:'pending',month:'Aug'},
      {po:'PO1098',item:'Sterilizer Module',qty:5,delivery:'21 Aug 2026',status:'transit',month:'Aug'},
      {po:'PO1080',item:'Diagnostic Scanner Unit',qty:1,delivery:'09 Aug 2026',status:'delivered',month:'Aug'},
      {po:'PO1042',item:'Sterilizer Module',qty:4,delivery:'14 Jun 2026',status:'delivered',month:'Jun'}
    ],
    invoices:[
      {inv:'INV-6021',amt:'₹3,20,000',stage:'approved',date:'13 Aug 2026'},
      {inv:'INV-6015',amt:'₹1,85,000',stage:'payment-due',date:'22 Aug 2026'},
      {inv:'INV-6002',amt:'₹2,40,000',stage:'paid',date:'02 Jul 2026'},
      {inv:'INV-5994',amt:'₹95,500',stage:'submitted',date:'12 Aug 2026'}
    ],
    docs:{},
    delayedShipment:{po:'PO1015', item:'Sterilizer Module', expected:'18 May 2026', delivered:'21 May 2026', lateDays:3},
    feedback:'Feedback: Consistent quality and documentation, no issues logged.', dueThisWeek:1
  },
  'HealthCorp':{
    pos:[
      {po:'PO1132',item:'Antipyretic Tablets',qty:600,delivery:'23 Aug 2026',status:'pending',month:'Aug'},
      {po:'PO1120',item:'Cough Syrup 100ml',qty:400,delivery:'18 Aug 2026',status:'transit',month:'Aug'},
      {po:'PO1099',item:'Antipyretic Tablets',qty:550,delivery:'05 Aug 2026',status:'delivered',month:'Aug'},
      {po:'PO1060',item:'Cough Syrup 100ml',qty:380,delivery:'20 May 2026',status:'delivered',month:'May'}
    ],
    invoices:[
      {inv:'INV-7040',amt:'₹48,200',stage:'review',date:'09 Aug 2026'},
      {inv:'INV-7035',amt:'₹36,000',stage:'payment-due',date:'26 Aug 2026'},
      {inv:'INV-7020',amt:'₹58,900',stage:'rejected',date:'11 Aug 2026',reason:'Missing supporting documents'},
      {inv:'INV-7005',amt:'₹71,400',stage:'paid',date:'18 Jul 2026'}
    ],
    docs:{'gst':{name:'GST registration renewal', status:'Expires in 25 days', detail:'Your GST registration certificate expires on 12 Sep 2026. Upload the renewed certificate before the deadline.'}},
    delayedShipment:{po:'PO1042', item:'Cough Syrup 100ml', expected:'04 Jun 2026', delivered:'07 Jun 2026', lateDays:3},
    feedback:'Feedback: Slight dip in on-time delivery, monitoring closely.', dueThisWeek:2
  },
  'BioGen':{
    pos:[
      {po:'PO1210',item:'Enzyme Concentrate',qty:150,delivery:'26 Aug 2026',status:'pending',month:'Aug'},
      {po:'PO1198',item:'Culture Media Pack',qty:220,delivery:'19 Aug 2026',status:'transit',month:'Aug'},
      {po:'PO1180',item:'Enzyme Concentrate',qty:130,delivery:'07 Aug 2026',status:'delivered',month:'Aug'},
      {po:'PO1140',item:'Culture Media Pack',qty:200,delivery:'28 Jun 2026',status:'delivered',month:'Jun'}
    ],
    invoices:[
      {inv:'INV-8030',amt:'₹66,000',stage:'submitted',date:'12 Aug 2026'},
      {inv:'INV-8022',amt:'₹49,500',stage:'payment-due',date:'03 Aug 2026',overdueDays:8},
      {inv:'INV-8010',amt:'₹82,000',stage:'approved',date:'14 Aug 2026'},
      {inv:'INV-7998',amt:'₹58,300',stage:'paid',date:'22 Jul 2026'}
    ],
    docs:{'iso14001':{name:'ISO 14001 certification', status:'Expires in 30 days', detail:'Your ISO 14001:2015 certification expires on 17 Sep 2026. Upload a renewed certificate to avoid disruption to new purchase orders.'}},
    delayedShipment:{po:'PO1105', item:'Culture Media Pack', expected:'10 Jun 2026', delivered:'14 Jun 2026', lateDays:4},
    feedback:'Feedback: Good responsiveness, one late shipment resolved quickly.', dueThisWeek:1
  },
  'Vedica Store':{
    pos:[
      {po:'PO1305',item:'Blister Packaging Roll',qty:1000,delivery:'27 Aug 2026',status:'pending',month:'Aug'},
      {po:'PO1290',item:'Carton Box 500ml',qty:800,delivery:'20 Aug 2026',status:'transit',month:'Aug'},
      {po:'PO1270',item:'Blister Packaging Roll',qty:950,delivery:'06 Aug 2026',status:'delivered',month:'Aug'},
      {po:'PO1230',item:'Carton Box 500ml',qty:700,delivery:'15 Apr 2026',status:'delivered',month:'Apr'}
    ],
    invoices:[
      {inv:'INV-9012',amt:'₹28,000',stage:'review',date:'10 Aug 2026'},
      {inv:'INV-9005',amt:'₹19,500',stage:'payment-due',date:'24 Aug 2026'},
      {inv:'INV-8990',amt:'₹34,000',stage:'paid',date:'05 Jul 2026'},
      {inv:'INV-8975',amt:'₹21,200',stage:'submitted',date:'13 Aug 2026'}
    ],
    docs:{},
    delayedShipment:{po:'PO1190', item:'Carton Box 500ml', expected:'02 Jun 2026', delivered:'04 Jun 2026', lateDays:2},
    feedback:'Feedback: Reliable packaging quality, on-time delivery trending up.', dueThisWeek:2
  }
};

let vendStatusFilter=null, vendMonthFilter=null, vendCurrentVendorName='AHB Pharma';

window.vendPillFor = function vendPillFor(s){ if(s==='delivered') return '<span class="pill green">Delivered</span>'; if(s==='transit') return '<span class="pill blue">In transit</span>'; if(s==='cancelled') return '<span class="pill red">Cancelled</span>'; return '<span class="pill amber">Pending</span>'; }
window.vendActionText = function vendActionText(r){
  const map={pending:'Acknowledge', transit:'Track', delivered:'Delivered', cancelled:'Cancelled'};
  return `<span style="color:var(--text-sec);font-weight:600;">${map[r.status]}</span>`;
}
window.vendUpdateFilterBar = function vendUpdateFilterBar(){
  const bar=document.getElementById('vendFilterBar');
  const chips=document.getElementById('vendFilterChips');
  if(!bar || !chips) return;

  const parts=[];
  if(vendStatusFilter) parts.push('Status: '+(vendStatusFilter==='active'?'Active (pending + in transit)':vendStatusFilter));
  if(vendMonthFilter) parts.push('Month: '+vendMonthFilter);
  if(!parts.length){ bar.style.display='none'; return; }
  bar.style.display='flex';
  chips.innerHTML = parts.map(p=>`<span class="active-filter-tag">${p}</span>`).join('');
}
// My purchase orders — report-only table, rows are not clickable
window.renderVendPOs = function renderVendPOs(){
  const count=document.getElementById('vendPOCount');
  const titleElement=document.getElementById('vendPOTitle');
  const body=document.getElementById('vendPOBody');
  if(!count || !titleElement || !body) return;

  let rows = vendPOs.slice();
  if(vendStatusFilter==='active') rows = rows.filter(r=>r.status==='pending'||r.status==='transit');
  else if(vendStatusFilter) rows = rows.filter(r=>r.status===vendStatusFilter);
  if(vendMonthFilter) rows = rows.filter(r=>r.month===vendMonthFilter);
  let title='My purchase orders';
  if(vendStatusFilter) title += ' — '+(vendStatusFilter==='active'?'active':vendStatusFilter);
  if(vendMonthFilter) title += ' · '+vendMonthFilter;
  titleElement.textContent = title;
  body.innerHTML = rows.length ? rows.map(r=>
    `<tr><td>${r.po}</td><td>${r.item}</td><td>${r.qty}</td><td>${r.delivery}</td><td>${vendPillFor(r.status)}</td><td>${vendActionText(r)}</td></tr>`
  ).join('') : '<tr class="empty-row"><td colspan="6">No purchase orders match this filter</td></tr>';
  vendUpdateFilterBar();
}
// Upcoming deliveries — report-only table, rows are not clickable
window.vendRenderUpcomingDeliveries = function vendRenderUpcomingDeliveries(){
  const body=document.getElementById('vendUpcomingBody');
  if(!body) return;

  const upcoming = vendPOs.filter(p=>p.status==='pending'||p.status==='transit').slice(0,3);
  body.innerHTML = upcoming.length ? upcoming.map(p=>
    `<tr><td>${p.po}</td><td>${p.item}</td><td>${p.qty}</td><td>${p.delivery}</td></tr>`
  ).join('') : '<tr class="empty-row"><td colspan="4">No upcoming deliveries</td></tr>';
}
window.vendParseAmt = function vendParseAmt(s){ return parseInt(String(s).replace(/[^\d]/g,''),10)||0; }
window.vendFormatL = function vendFormatL(n){ return '₹'+(n/100000).toFixed(2)+'L'; }
// Payment center — computed live from the active vendor's invoices
window.vendRenderPaymentCenter = function vendRenderPaymentCenter(){
  const tiles=document.querySelector('#vendPaymentCard .tile-row');
  if(!tiles) return;

  const due = vendInvoices.filter(v=>v.stage==='payment-due');
  const totalPending = due.reduce((s,v)=>s+vendParseAmt(v.amt),0);
  const overdueList = due.filter(v=>v.overdueDays).sort((a,b)=>b.overdueDays-a.overdueDays);
  const upcomingList = due.filter(v=>!v.overdueDays);
  const totalHtml = `<div class="payable-tile" onclick="vendShowDetail('invoice-stage','payment-due')"><p class="kpi-label">Total pending</p><p class="kpi-value" style="font-size:17px;">${due.length?vendFormatL(totalPending):'₹0.00L'}</p><div class="kpi-sub flat">${due.length} invoice${due.length===1?'':'s'}</div></div>`;
  const upcomingHtml = upcomingList.length
    ? `<div class="payable-tile" onclick="vendShowDetail('invoice','${upcomingList[0].inv}')"><p class="kpi-label">Upcoming payment</p><p class="kpi-value" style="font-size:17px;">${upcomingList[0].amt}</p><div class="kpi-sub flat">${upcomingList[0].date}</div></div>`
    : `<div class="payable-tile"><p class="kpi-label">Upcoming payment</p><p class="kpi-value" style="font-size:17px;">—</p><div class="kpi-sub flat">None due</div></div>`;
  const overdueHtml = overdueList.length
    ? `<div class="payable-tile" onclick="vendShowDetail('invoice','${overdueList[0].inv}')"><p class="kpi-label">Overdue</p><p class="kpi-value" style="font-size:17px;color:var(--red);">${overdueList[0].amt}</p><div class="kpi-sub down">${overdueList[0].overdueDays} days overdue</div></div>`
    : `<div class="payable-tile"><p class="kpi-label">Overdue</p><p class="kpi-value" style="font-size:17px;color:var(--teal);">₹0</p><div class="kpi-sub flat">None overdue</div></div>`;
  tiles.innerHTML = totalHtml+upcomingHtml+overdueHtml;
}
// Invoice status stage counts — computed live from the active vendor's invoices
window.vendRenderInvoiceStages = function vendRenderInvoiceStages(){
  const grid=document.getElementById('vendInvoiceStageGrid');
  if(!grid) return;

  const stages=['submitted','review','approved','payment-due','paid','rejected'];
  const counts={}; stages.forEach(s=>counts[s]=0);
  vendInvoices.forEach(v=>{ if(counts[v.stage]!==undefined) counts[v.stage]++; });
  grid.innerHTML = stages.map(s=>
    `<div class="exception-chip" onclick="vendShowDetail('invoice-stage','${s}')"><div class="ec-count">${counts[s]}</div><div class="ec-label">${vendStageLabel[s]}</div></div>`
  ).join('');
}
// Action Center — combines compliance alerts, action items and exceptions/disputes into one clickable list,
// generated live from the active vendor's POs, invoices and documents so the KPI count is always in sync.
window.vendRenderActionCenter = function vendRenderActionCenter(){
  const list=document.getElementById('vendActionList');
  const count=document.getElementById('vendActionCount');
  const actionKpi=document.getElementById('vendKpiAction');
  if(!list || !count || !actionKpi) return;

  const items=[];
  vendInvoices.filter(v=>v.stage==='rejected').forEach(v=>{
    items.push({icon:'crit', text:`<b>${v.inv}</b> rejected — ${(v.reason||'see details').toLowerCase()}`, sub:'Resubmission required', click:`vendShowDetail('invoice','${v.inv}')`});
  });
  vendPOs.filter(p=>p.status==='pending').forEach(p=>{
    items.push({icon:'warn', text:`<b>${p.po}</b> awaiting your acknowledgement`, sub:'Action needed', click:`vendShowDetail('po','${p.po}')`});
  });
  vendPOs.filter(p=>p.status==='transit').forEach(p=>{
    items.push({icon:'info', text:`<b>${p.po}</b> in transit — delivery expected ${p.delivery}`, sub:'Prepare to receive', click:`vendShowDetail('po','${p.po}')`});
  });
  Object.keys(vendDocs).forEach(k=>{
    const d=vendDocs[k];
    const critical = /missing/i.test(d.status);
    items.push({icon: critical?'crit':'warn', text:`${d.name} — <b>${d.status.toLowerCase()}</b>`, sub:'Upload required', click:`vendShowDetail('doc','${k}')`});
  });
  vendInvoices.filter(v=>v.stage==='payment-due' && v.overdueDays).forEach(v=>{
    items.push({icon:'crit', text:`<b>${v.inv}</b> payment overdue by ${v.overdueDays} days`, sub:'Settle to avoid penalty', click:`vendShowDetail('invoice','${v.inv}')`});
  });
  list.innerHTML = items.length ? items.map(it=>
    `<div class="alert-item row-click" onclick="${it.click}"><div class="alert-icon ${it.icon}">${it.icon==='info'?'i':'!'}</div><div><div class="alert-text">${it.text}</div><div class="alert-time">${it.sub}</div></div></div>`
  ).join('') : '<p style="font-size:12.5px;color:var(--text-sec);">No action items — you\'re all caught up.</p>';
  count.textContent = items.length+' item'+(items.length===1?'':'s');
  actionKpi.textContent = items.length;
}
window.vendFilterActive = function vendFilterActive(){ vendStatusFilter='active'; renderVendPOs(); }
// Resets KPIs/feedback to the active vendor's defaults (not always AHB Pharma, once a vendor has been switched)
window.vendApplyKpis = function vendApplyKpis(){
  const p = vendorProfiles[vendCurrentVendorName];
  const d = vendorVMSData[vendCurrentVendorName];
  document.getElementById('vendKpiScore').textContent = p.score;
  document.getElementById('vendKpiScoreSub').textContent = 'View breakdown';
  document.getElementById('vendKpiOTD').textContent = p.otd;
  const activeCount = vendPOs.filter(x=>x.status==='pending'||x.status==='transit').length;
  document.getElementById('vendKpiActivePOs').textContent = activeCount;
  document.getElementById('vendKpiActivePOsSub').textContent = (d.dueThisWeek||0)+' due this week';
  document.getElementById('vendFeedback').textContent = d.feedback;
}
window.vendResetAll = function vendResetAll(){
  vendStatusFilter=null; vendMonthFilter=null;
  vendApplyKpis();
  renderVendPOs();
  vendCloseDetail();
}
window.vendFlashCard = function vendFlashCard(id){
  const card=document.getElementById(id);
  card.scrollIntoView({behavior:'smooth', block:'center'});
  card.style.transition='box-shadow .2s, border-color .2s';
  card.style.borderColor='#2A5FD9'; card.style.boxShadow='0 0 0 3px rgba(42,95,217,0.15)';
  setTimeout(()=>{ card.style.borderColor=''; card.style.boxShadow=''; }, 1400);
}
// Switches the entire Vendor dashboard to the selected vendor's data
window.vendSwitchVendor = function vendSwitchVendor(name){
  if(!vendorVMSData[name]) return;
  vendCurrentVendorName = name;
  const d = vendorVMSData[name];
  vendPOs = d.pos; vendInvoices = d.invoices; vendDocs = d.docs; vendDelayedShipment = d.delayedShipment;
  vendStatusFilter=null; vendMonthFilter=null;

  document.getElementById('vendPageDesc').textContent = name+' · Self-service portal';

  const p = vendorProfiles[name];
  vendPerfChart.data.datasets[0].data = p.perf;
  vendPerfChart.update();

  const statusCounts={delivered:0, pending:0, transit:0, cancelled:0};
  vendPOs.forEach(x=>{ if(statusCounts[x.status]!==undefined) statusCounts[x.status]++; });
  vendPOStatusChart.data.datasets[0].data = [statusCounts.delivered, statusCounts.pending, statusCounts.transit, statusCounts.cancelled];
  vendPOStatusChart.update();

  vendApplyKpis();
  renderVendPOs();
  vendRenderInvoiceStages();
  vendRenderPaymentCenter();
  vendRenderActionCenter();
  vendRenderUpcomingDeliveries();
  vendCloseDetail();
}

const vendPOStatusChart = createChart('vendPOStatus', {
  type:'doughnut', data:{labels:['Completed','Pending','In transit','Cancelled'],
    datasets:[{data:[4,2,1,1], backgroundColor:['#0F9E7A','#C9781C','#2A5FD9','#D14343'], borderWidth:3, borderColor:'#fff'}]},
  options:{responsive:true, maintainAspectRatio:false, cutout:'70%', plugins:{legend:{display:false}},
    onClick:(evt,els)=>{ if(els.length){ const statuses=['delivered','pending','transit','cancelled']; vendStatusFilter=statuses[els[0].index]; renderVendPOs(); } }
  }
});

const vendPerfChart = createChart('vendPerfTrend', {
  type:'line', data:{labels:['Mar','Apr','May','Jun','Jul','Aug'],
    datasets:[{data:[78,80,82,85,84,88], borderColor:'#C9781C', backgroundColor:'rgba(201,120,28,0.08)', fill:true, tension:.35, pointRadius:4, pointBackgroundColor:'#C9781C', borderWidth:2}]},
  options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}}, scales:{x:baseGrid(), y:{...baseGrid(), min:60, max:100}},
    onClick:(evt,els)=>{ if(els.length){
      const labels=vendPerfChart.data.labels, vals=vendPerfChart.data.datasets[0].data;
      const i=els[0].index; const m=labels[i];
      document.getElementById('vendKpiScore').textContent = vals[i]+' / 100';
      document.getElementById('vendKpiScoreSub').textContent = 'Score as of '+m+' 2026';
      const fb = (vendCurrentVendorName==='AHB Pharma' && vendFeedbackByMonth[m]) ? vendFeedbackByMonth[m] : 'Feedback: Score for '+m+' 2026 was '+vals[i]+'/100.';
      document.getElementById('vendFeedback').textContent = fb;
      vendMonthFilter = m;
      renderVendPOs();
    }}
  }
});

// Shared detail panel — score breakdown / on-time-delivery detail / invoice stage lists / single invoice / PO / document
window.vendShowDetail = function vendShowDetail(type, key){
  const panel=document.getElementById('vendDetailPanel');
  const title=document.getElementById('vendDetailTitle');
  const body=document.getElementById('vendDetailBody');
  panel.style.display='block';

  if(type==='score'){
    const scoreNum = parseInt(vendorProfiles[vendCurrentVendorName].score, 10);
    const clamp=v=>Math.max(0, Math.min(100, v));
    const b={delivery:clamp(scoreNum+4), quality:clamp(scoreNum-3), compliance:clamp(scoreNum+2), fulfilment:clamp(scoreNum+1), price:clamp(scoreNum-4)};
    title.textContent='Performance score breakdown (avg = '+scoreNum+'/100)';
    body.innerHTML = `<div class="funnel">
      <div class="funnel-row"><div class="funnel-label">Delivery</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:${b.delivery}%;background:#2A5FD9;">${b.delivery}</div></div></div>
      <div class="funnel-row"><div class="funnel-label">Quality</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:${b.quality}%;background:#7A4DE0;">${b.quality}</div></div></div>
      <div class="funnel-row"><div class="funnel-label">Compliance</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:${b.compliance}%;background:#0F9E7A;">${b.compliance}</div></div></div>
      <div class="funnel-row"><div class="funnel-label">Fulfilment</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:${b.fulfilment}%;background:#C9781C;">${b.fulfilment}</div></div></div>
      <div class="funnel-row"><div class="funnel-label">Price</div><div class="funnel-bar-bg"><div class="funnel-bar" style="width:${b.price}%;background:#D14343;">${b.price}</div></div></div>
    </div>`;
  } else if(type==='otif'){
    const otdNum = parseInt(vendorProfiles[vendCurrentVendorName].otd, 10);
    const total=18; const onTime=Math.round(total*otdNum/100); const late=total-onTime;
    title.textContent='On-time delivery — last '+total+' shipments';
    body.innerHTML = `<div class="tile-row">
      <div class="payable-tile"><p class="kpi-label">On time</p><p class="kpi-value" style="font-size:19px;color:var(--teal);">${onTime}</p></div>
      <div class="payable-tile" onclick="vendShowDetail('delay')"><p class="kpi-label">Late</p><p class="kpi-value" style="font-size:19px;color:var(--red);">${late}</p><div class="kpi-sub down">Click for detail</div></div>
    </div>`;
  } else if(type==='delay'){
    title.textContent='Delayed shipment detail';
    const d=vendDelayedShipment;
    body.innerHTML = `<table><tr><th>PO number</th><th>Item</th><th>Expected</th><th>Delivered</th><th>Days late</th></tr>
      <tr><td>${d.po}</td><td>${d.item}</td><td>${d.expected}</td><td>${d.delivered}</td><td>${d.lateDays}</td></tr></table>`;
  } else if(type==='invoice-stage'){
    title.textContent = vendStageLabel[key]+' invoices';
    const rows = vendInvoices.filter(v=>v.stage===key);
    body.innerHTML = rows.length ? `<table><tr><th>Invoice</th><th>Amount</th><th>Date</th><th></th></tr>` +
      rows.map(r=>`<tr class="row-click" onclick="vendShowDetail('invoice','${r.inv}')"><td>${r.inv}</td><td>${r.amt}</td><td>${r.date}</td><td><span class="vendor-link">Details →</span></td></tr>`).join('') + `</table>`
      : '<p style="font-size:12.5px;color:var(--text-sec);">No invoices currently in this stage.</p>';
  } else if(type==='invoice'){
    const inv = vendInvoices.find(v=>v.inv===key);
    title.textContent = 'Invoice details — '+key;
    let extra='';
    if(inv.stage==='rejected'){
      extra = `<div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border);">
        <p style="font-size:12.5px;color:var(--red);font-weight:600;margin:0 0 4px;">Rejection reason</p>
        <p style="font-size:12.5px;color:var(--text-sec);margin:0 0 10px;">${inv.reason}</p>
        <span class="vendor-link">Upload corrected invoice →</span>
      </div>`;
    } else if(inv.overdueDays){
      extra = `<div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border);"><span class="pill red">Overdue by ${inv.overdueDays} days</span></div>`;
    }
    body.innerHTML = `<div class="s360-kpis" style="grid-template-columns:1fr 1fr 1fr;">
      <div class="s360-kpi"><div class="l">Amount</div><div class="v">${inv.amt}</div></div>
      <div class="s360-kpi"><div class="l">Stage</div><div class="v">${vendStageLabel[inv.stage]}</div></div>
      <div class="s360-kpi"><div class="l">Date</div><div class="v" style="font-size:14px;">${inv.date}</div></div>
    </div>${extra}`;
  } else if(type==='po'){
    const p = vendPOs.find(x=>x.po===key);
    title.textContent = 'PO details — '+key;
    const actionMap={pending:'Acknowledge order', transit:'Track shipment', delivered:'View delivery record', cancelled:'View cancellation record'};
    body.innerHTML = `<div class="s360-kpis" style="grid-template-columns:1fr 1fr 1fr 1fr;">
      <div class="s360-kpi"><div class="l">Item</div><div class="v" style="font-size:14px;">${p.item}</div></div>
      <div class="s360-kpi"><div class="l">Quantity</div><div class="v">${p.qty}</div></div>
      <div class="s360-kpi"><div class="l">Expected</div><div class="v" style="font-size:14px;">${p.delivery}</div></div>
      <div class="s360-kpi"><div class="l">Status</div><div class="v" style="font-size:14px;">${vendPillFor(p.status)}</div></div>
    </div>
    <div style="margin-top:12px;"><span class="vendor-link">${actionMap[p.status]} →</span></div>`;
  } else if(type==='doc'){
    const d = vendDocs[key];
    title.textContent = d.name;
    body.innerHTML = `<p style="font-size:12.5px;color:var(--text-sec);line-height:1.6;margin:0 0 12px;">${d.detail}</p><span class="vendor-link">Upload replacement document →</span>`;
  }
  panel.scrollIntoView({behavior:'smooth', block:'nearest'});
}
window.vendCloseDetail = function vendCloseDetail(){ document.getElementById('vendDetailPanel').style.display='none'; }

renderVendPOs();

/* ============ SUPPLIER 360 MODAL (shared) ============ */
const vendorProfiles={
  'AHB Pharma':{id:'VMS-0142',cat:'Medicine',since:2019,spend:'₹18.4L',score:'88 / 100',otd:'94%',perf:[78,80,82,85,84,88]},
  'XYZ Chemicals':{id:'VMS-0198',cat:'Raw material',since:2020,spend:'₹15.1L',score:'56 / 100',otd:'86%',perf:[70,68,65,60,58,56]},
  'MediLife Ltd':{id:'VMS-0211',cat:'Equipment',since:2018,spend:'₹12.7L',score:'91 / 100',otd:'89%',perf:[84,86,87,89,90,91]},
  'HealthCorp':{id:'VMS-0234',cat:'Medicine',since:2021,spend:'₹9.3L',score:'64 / 100',otd:'91%',perf:[66,65,64,63,64,64]},
  'BioGen':{id:'VMS-0267',cat:'Raw material',since:2022,spend:'₹7.6L',score:'82 / 100',otd:'78%',perf:[75,77,78,80,81,82]},
  'Vedica Store':{id:'VMS-0301',cat:'Packaging',since:2023,spend:'₹4.2L',score:'90 / 100',otd:'95%',perf:[85,86,88,89,90,90]}
};

// Populate the Vendor dashboard's vendor dropdown and render its data-driven sections for the default vendor
const vendorSelect=document.getElementById('vendVendorSelect');
if(vendorSelect) {
  vendorSelect.innerHTML = Object.keys(vendorProfiles).map(n=>
    `<option value="${n}"${n===vendCurrentVendorName?' selected':''}>${n}</option>`
  ).join('');
}
vendRenderInvoiceStages();
vendRenderPaymentCenter();
vendRenderActionCenter();
vendRenderUpcomingDeliveries();

let s360PerfChart=null;
window.ensureS360Perf = function ensureS360Perf(data){
  if(s360PerfChart){ s360PerfChart.data.datasets[0].data = data; s360PerfChart.update(); return; }
  s360PerfChart = createChart('chS360Perf', {
    type:'line', data:{labels:['Mar','Apr','May','Jun','Jul','Aug'],
      datasets:[{data:data, borderColor:'#C9781C', backgroundColor:'rgba(201,120,28,0.08)', fill:true, tension:.35, pointRadius:3, pointBackgroundColor:'#C9781C', borderWidth:2}]},
    options:{responsive:true, maintainAspectRatio:false, plugins:{legend:{display:false}}, scales:{x:baseGrid(), y:{...baseGrid(), min:40, max:100}}}
  });
}
window.openS360 = function openS360(name){
  const p = vendorProfiles[name] || {id:'VMS-0000',cat:'General',since:2024,spend:'—',score:'—',otd:'—',perf:[70,72,74,75,76,78]};
  document.getElementById('s360name').textContent = name;
  document.getElementById('s360meta').textContent = `Vendor ID ${p.id} · ${p.cat} category · Active since ${p.since}`;
  document.getElementById('s360Spend').textContent = p.spend;
  document.getElementById('s360Score').textContent = p.score;
  document.getElementById('s360OTD').textContent = p.otd;
  document.getElementById('s360overlay').classList.add('open');
  document.body.style.overflow='hidden';
  s360tab('overview', document.querySelector('.s360-tab[data-p="overview"]'));
  setTimeout(()=>ensureS360Perf(p.perf), 50);
}
window.closeS360 = function closeS360(){ document.getElementById('s360overlay').classList.remove('open'); document.body.style.overflow=''; }
window.s360tab = function s360tab(id, el){
  document.querySelectorAll('.s360-panel').forEach(p=>p.classList.remove('active'));
  document.querySelectorAll('.s360-tab').forEach(t=>t.classList.remove('active'));
  document.getElementById('p-'+id).classList.add('active');
  el.classList.add('active');
}

}


// Dashboard role, KPI, and insight configuration.
export const INSIGHT_CONFIGS = {
  finance: {
    monthlySpend: {
      id: 'monthlySpend',
      title: 'Monthly Spend Trend',
      component: 'MonthlySpendCard',
      span: 1,
      chartType: 'bar',
      dataKey: 'finSpendChart',
    },
    categorySpend: {
      id: 'categorySpend',
      title: 'Spend by Category',
      component: 'CategorySpendCard',
      span: 1,
      chartType: 'horizontalBar',
      dataKey: 'finCategory',
    },
    paymentStatus: {
      id: 'paymentStatus',
      title: 'Payment Status',
      component: 'PaymentStatusCard',
      span: 1,
      chartType: 'doughnut',
      dataKey: 'finPayStatus',
    },
    topVendors: {
      id: 'topVendors',
      title: 'Top Vendors by Spend',
      component: 'TopVendorsCard',
      span: 1,
      chartType: 'horizontalBar',
      dataKey: 'finTopVendors',
    },
    outstandingPayables: {
      id: 'outstandingPayables',
      title: 'Outstanding Payables',
      component: 'OutstandingPayablesCard',
      span: 1,
      chartType: 'tiles',
      dataKey: 'finPayablesBreakdown',
    },
    aging: {
      id: 'aging',
      title: 'AP Aging',
      component: 'AgingCard',
      span: 1,
      chartType: 'bar',
      dataKey: 'finAgingChart',
    },
    upcomingPayments: {
      id: 'upcomingPayments',
      title: 'Upcoming Payments',
      component: 'UpcomingPaymentsCard',
      span: 2,
      chartType: 'table',
    },
    invoiceExceptions: {
      id: 'invoiceExceptions',
      title: 'Invoice Exceptions',
      component: 'InvoiceExceptionsCard',
      span: 2,
      chartType: 'chips',
      dataKey: 'finExceptionGrid',
    },
    invoiceTable: {
      id: 'invoiceTable',
      title: 'Invoice Table',
      component: 'InvoiceTableCard',
      span: 2,
      chartType: 'table',
    },
  },
  inventory: {
    stockMovement: {
      id: 'stockMovement',
      title: 'Stock Movement Trend',
      component: 'StockMovementCard',
      span: 1,
      chartType: 'line',
      dataKey: 'opsMovement',
    },
    fulfilmentFunnel: {
      id: 'fulfilmentFunnel',
      title: 'Fulfilment Funnel',
      component: 'FulfilmentFunnelCard',
      span: 1,
      chartType: 'funnel',
      dataKey: 'opsFunnel',
    },
    inventoryCategory: {
      id: 'inventoryCategory',
      title: 'Inventory by Category',
      component: 'InventoryCategoryCard',
      span: 1,
      chartType: 'horizontalBar',
      dataKey: 'opsCategoryChart',
    },
    vendorDelays: {
      id: 'vendorDelays',
      title: 'Vendor Delays',
      component: 'VendorDelaysCard',
      span: 1,
      chartType: 'horizontalBar',
      dataKey: 'opsDelayChart',
    },
    slowStock: {
      id: 'slowStock',
      title: 'Slow Moving Stock',
      component: 'SlowStockCard',
      span: 1,
      chartType: 'bar',
      dataKey: 'opsSlowChart',
    },
    inventoryActionCenter: {
      id: 'inventoryActionCenter',
      title: 'Action Center',
      component: 'ActionCenterCard',
      span: 1,
      chartType: 'list',
    },
    reorderTable: {
      id: 'reorderTable',
      title: 'Reorder & Stockout Risk',
      component: 'ReorderTableCard',
      span: 2,
      chartType: 'table',
    },
  },
  management: {
    vendorGrowth: {
      id: 'vendorGrowth',
      title: 'Vendor Growth',
      component: 'VendorGrowthCard',
      span: 1,
      chartType: 'bar',
      dataKey: 'mgmtGrowth',
    },
    procurementSavings: {
      id: 'procurementSavings',
      title: 'Procurement Savings',
      component: 'ProcurementSavingsCard',
      span: 1,
      chartType: 'horizontalBar',
      dataKey: 'mgmtSavingsChart',
    },
    categoryMix: {
      id: 'categoryMix',
      title: 'Category Mix',
      component: 'CategoryMixCard',
      span: 1,
      chartType: 'horizontalBar',
      dataKey: 'mgmtCategoryMix',
    },
    managementActionCenter: {
      id: 'managementActionCenter',
      title: 'Action Center',
      component: 'ActionCenterCard',
      span: 1,
      chartType: 'list',
    },
    supplierConcentration: {
      id: 'supplierConcentration',
      title: 'Supplier Concentration',
      component: 'SupplierConcentrationCard',
      span: 2,
      chartType: 'horizontalBar',
      dataKey: 'mgmtConcentrationChart',
    },
  },
  vendor: {
    poStatus: {
      id: 'poStatus',
      title: 'PO Status',
      component: 'POStatusCard',
      span: 1,
      chartType: 'funnel',
      dataKey: 'vendPOStatus',
    },
    performanceTrend: {
      id: 'performanceTrend',
      title: 'Performance Trend',
      component: 'PerformanceTrendCard',
      span: 1,
      chartType: 'line',
      dataKey: 'vendPerformanceTrend',
    },
    invoiceStatus: {
      id: 'invoiceStatus',
      title: 'Invoice Status',
      component: 'InvoiceStatusCard',
      span: 2,
      chartType: 'tiles',
      dataKey: 'vendInvoiceStageGrid',
    },
    paymentCenter: {
      id: 'paymentCenter',
      title: 'Payment Center',
      component: 'PaymentCenterCard',
      span: 1,
      chartType: 'tiles',
      dataKey: 'vendPaymentCard',
    },
    vendorActionCenter: {
      id: 'vendorActionCenter',
      title: 'Action Center',
      component: 'ActionCenterCard',
      span: 1,
      chartType: 'list',
    },
    upcomingDeliveries: {
      id: 'upcomingDeliveries',
      title: 'Upcoming Deliveries',
      component: 'UpcomingDeliveriesCard',
      span: 2,
      chartType: 'table',
    },
    purchaseOrders: {
      id: 'purchaseOrders',
      title: 'Purchase Orders',
      component: 'PurchaseOrdersCard',
      span: 2,
      chartType: 'table',
    },
  },
};

export function getInsightConfigsForRole(role) {
  const permissions = {
    finance_user: ['monthlySpend', 'categorySpend', 'paymentStatus', 'topVendors'],
    finance_admin: ['monthlySpend', 'categorySpend', 'paymentStatus', 'topVendors', 'outstandingPayables', 'aging', 'upcomingPayments', 'invoiceExceptions', 'invoiceTable'],
    operations_user: ['stockMovement', 'fulfilmentFunnel', 'inventoryCategory', 'vendorDelays'],
    operations_admin: ['stockMovement', 'fulfilmentFunnel', 'inventoryCategory', 'vendorDelays', 'slowStock', 'inventoryActionCenter', 'reorderTable'],
    management_user: ['vendorGrowth', 'procurementSavings', 'categoryMix', 'managementActionCenter'],
    management_admin: ['vendorGrowth', 'procurementSavings', 'categoryMix', 'managementActionCenter', 'supplierConcentration'],
    vendor_user: ['poStatus', 'performanceTrend', 'invoiceStatus', 'paymentCenter'],
    vendor_admin: ['poStatus', 'performanceTrend', 'invoiceStatus', 'paymentCenter', 'vendorActionCenter', 'upcomingDeliveries', 'purchaseOrders'],
  };

  const insightIds = permissions[role] || permissions.finance_user;
  const domain = role.startsWith('operations_') ? 'inventory' : role.split('_')[0];

  return insightIds.map(id => INSIGHT_CONFIGS[domain][id]).filter(Boolean);
}

export function getAllInsightConfigs(domain) {
  return domain
    ? Object.values(INSIGHT_CONFIGS[domain] || {})
    : Object.values(INSIGHT_CONFIGS).flatMap(Object.values);
}

export const KPI_CONFIGS = {
  finance: {
    totalSpend: {
      id: 'totalSpend',
      label: 'Total Spend',
      value: '₹84.2L',
      trend: { value: '▲ 6.4% vs last month', type: 'up' },
      accent: 'blue',
      onClick: () => window.finUpdateMonth?.('Aug'),
    },
    overduePayables: {
      id: 'overduePayables',
      label: 'Overdue Payables',
      value: '₹7.24L',
      trend: { value: '7 invoices overdue', type: 'down' },
      accent: 'red',
      onClick: () => window.finPayablesClick?.('overdue'),
    },
    costSavings: {
      id: 'costSavings',
      label: 'Cost Savings',
      value: '₹1.4L',
      trend: { value: '▲ vs budget', type: 'up' },
      accent: 'teal',
      onClick: null,
    },
    avgPaymentCycle: {
      id: 'avgPaymentCycle',
      label: 'Avg Payment Cycle',
      value: '14.2 days',
      trend: { value: '— stable', type: 'flat' },
      accent: 'purple',
      onClick: null,
    },
    budgetUtilised: {
      id: 'budgetUtilised',
      label: 'Budget Utilised',
      value: '72%',
      trend: { value: 'on track · FY26', type: 'up' },
      accent: 'amber',
      onClick: null,
    },
    invoiceCount: {
      id: 'invoiceCount',
      label: 'Invoice Count',
      value: '24',
      trend: { value: '▲ 3 this month', type: 'up' },
      accent: 'blue',
      onClick: null,
    },
  },
  inventory: {
    currentStock: {
      id: 'currentStock',
      label: 'Current Stock',
      value: '657 units',
      trend: { value: '48 active SKUs', type: 'flat' },
      accent: 'teal',
      onClick: null,
    },
    inventoryValue: {
      id: 'inventoryValue',
      label: 'Inventory Value',
      value: '₹10.2L',
      trend: { value: '▲ 4.2% MoM', type: 'up' },
      accent: 'blue',
      onClick: null,
    },
    stockCoverage: {
      id: 'stockCoverage',
      label: 'Stock Coverage',
      value: '21.6 days',
      trend: { value: '▼ 3.6d vs last month', type: 'down' },
      accent: 'purple',
      onClick: null,
    },
    stockoutRisk: {
      id: 'stockoutRisk',
      label: 'Stockout Risk',
      value: '8 at-risk',
      trend: { value: '3 critical · 5 at-risk · view list', type: 'down' },
      accent: 'red',
      onClick: () => window.opsShowRiskAll?.(),
    },
    pendingOrders: {
      id: 'pendingOrders',
      label: 'Pending Orders',
      value: '10',
      trend: { value: 'in pipeline', type: 'flat' },
      accent: 'amber',
      onClick: null,
    },
    avgFulfilmentTime: {
      id: 'avgFulfilmentTime',
      label: 'Avg Fulfilment Time',
      value: '3.4 days',
      trend: { value: '0.6d faster', type: 'up' },
      accent: 'teal',
      onClick: null,
    },
  },
  management: {
    totalProcurementSpend: {
      id: 'totalProcurementSpend',
      label: 'Total Procurement Spend',
      value: '₹6.03 Cr',
      trend: { value: '▲ 14.2% YoY', type: 'up' },
      accent: 'purple',
      onClick: () => window.mgmtFlashCategoryMix?.(),
    },
    avgVendorScore: {
      id: 'avgVendorScore',
      label: 'Avg Vendor Score',
      value: '82 / 100',
      trend: { value: '▲ 3 pts · view breakdown', type: 'up' },
      accent: 'blue',
      onClick: () => window.mgmtShowDetail?.('score'),
    },
    supplierOtif: {
      id: 'supplierOtif',
      label: 'Supplier OTIF',
      value: '87.4%',
      trend: { value: '▲ 2.1 pts · view trend', type: 'up' },
      accent: 'teal',
      onClick: () => window.mgmtShowDetail?.('otif'),
    },
    spendVsBudget: {
      id: 'spendVsBudget',
      label: 'Spend vs Budget',
      value: '72%',
      trend: { value: 'on track', type: 'up' },
      accent: 'amber',
      onClick: null,
    },
    supplierRiskExposure: {
      id: 'supplierRiskExposure',
      label: 'Supplier Risk Exposure',
      value: '₹1.86 Cr',
      trend: { value: '3 high · 5 med · 2 low', type: 'down' },
      accent: 'red',
      onClick: () => window.mgmtShowDetail?.('risk'),
    },
  },
  vendor: {
    performanceScore: {
      id: 'performanceScore',
      label: 'Performance Score',
      value: '88 / 100',
      trend: { value: '▲ 4 pts · view breakdown', type: 'up' },
      accent: 'amber',
      onClick: () => window.vendShowDetail?.('score'),
    },
    activePOs: {
      id: 'activePOs',
      label: 'Active POs',
      value: '7',
      trend: { value: '2 due this week', type: 'flat' },
      accent: 'blue',
      onClick: () => window.vendFilterActive?.(),
    },
    onTimeDelivery: {
      id: 'onTimeDelivery',
      label: 'On-time Delivery',
      value: '94%',
      trend: { value: '▲ 2% · view detail', type: 'up' },
      accent: 'teal',
      onClick: () => window.vendShowDetail?.('otif'),
    },
    actionRequired: {
      id: 'actionRequired',
      label: 'Action Required',
      value: '4',
      trend: { value: 'needs your attention', type: 'down' },
      accent: 'purple',
      onClick: () => window.vendFlashCard?.('vendActionCard'),
    },
  },
};

export function getKpiConfigsForRole(role) {
  const permissions = {
    finance_user: ['totalSpend', 'overduePayables', 'costSavings'],
    finance_admin: ['totalSpend', 'overduePayables', 'costSavings', 'avgPaymentCycle', 'budgetUtilised', 'invoiceCount'],
    operations_user: ['currentStock', 'inventoryValue', 'stockCoverage'],
    operations_admin: ['currentStock', 'inventoryValue', 'stockCoverage', 'stockoutRisk', 'pendingOrders', 'avgFulfilmentTime'],
    management_user: ['totalProcurementSpend', 'avgVendorScore', 'supplierOtif'],
    management_admin: ['totalProcurementSpend', 'avgVendorScore', 'supplierOtif', 'spendVsBudget', 'supplierRiskExposure'],
    vendor_user: ['performanceScore', 'activePOs', 'onTimeDelivery'],
    vendor_admin: ['performanceScore', 'activePOs', 'onTimeDelivery', 'actionRequired'],
  };

  const kpiIds = permissions[role] || permissions.finance_user;
  const domain = role.startsWith('operations_') ? 'inventory' : role.split('_')[0];

  return kpiIds
    .map(id => KPI_CONFIGS[domain][id])
    .filter(Boolean)
    .map((config) => (
      config.id === 'overduePayables' && role !== 'finance_admin'
        ? { ...config, onClick: null }
        : config
    ));
}

export function getAllKpiConfigs(domain) {
  return domain
    ? Object.values(KPI_CONFIGS[domain] || {})
    : Object.values(KPI_CONFIGS).flatMap(Object.values);
}

export const ROLE_PERMISSIONS = {
  finance_user: {
    label: 'Finance User',
    kpis: ['totalSpend', 'overduePayables', 'costSavings'],
    insights: ['monthlySpend', 'categorySpend', 'paymentStatus', 'topVendors'],
    canAccess: ['finance'],
  },
  finance_admin: {
    label: 'Finance Admin',
    kpis: ['totalSpend', 'overduePayables', 'costSavings', 'avgPaymentCycle', 'budgetUtilised', 'invoiceCount'],
    insights: ['monthlySpend', 'categorySpend', 'paymentStatus', 'topVendors', 'outstandingPayables', 'aging', 'upcomingPayments', 'invoiceExceptions', 'invoiceTable'],
    canAccess: ['finance'],
  },
  operations_user: {
    label: 'Operations User',
    kpis: ['currentStock', 'inventoryValue', 'stockCoverage'],
    insights: ['stockMovement', 'fulfilmentFunnel', 'inventoryCategory', 'vendorDelays'],
    canAccess: ['inventory'],
  },
  operations_admin: {
    label: 'Operations Admin',
    kpis: ['currentStock', 'inventoryValue', 'stockCoverage', 'stockoutRisk', 'pendingOrders', 'avgFulfilmentTime'],
    insights: ['stockMovement', 'fulfilmentFunnel', 'inventoryCategory', 'vendorDelays', 'slowStock', 'inventoryActionCenter', 'reorderTable'],
    canAccess: ['inventory'],
  },
  management_user: {
    label: 'Management User',
    kpis: ['totalProcurementSpend', 'avgVendorScore', 'supplierOtif'],
    insights: ['vendorGrowth', 'procurementSavings', 'categoryMix', 'managementActionCenter'],
    canAccess: ['management'],
  },
  management_admin: {
    label: 'Management Admin',
    kpis: ['totalProcurementSpend', 'avgVendorScore', 'supplierOtif', 'spendVsBudget', 'supplierRiskExposure'],
    insights: ['vendorGrowth', 'procurementSavings', 'categoryMix', 'managementActionCenter', 'supplierConcentration'],
    canAccess: ['management'],
  },
  vendor_user: {
    label: 'Vendor User',
    kpis: ['performanceScore', 'activePOs', 'onTimeDelivery'],
    insights: ['poStatus', 'performanceTrend', 'invoiceStatus', 'paymentCenter'],
    canAccess: ['vendor'],
  },
  vendor_admin: {
    label: 'Vendor Admin',
    kpis: ['performanceScore', 'activePOs', 'onTimeDelivery', 'actionRequired'],
    insights: ['poStatus', 'performanceTrend', 'invoiceStatus', 'paymentCenter', 'vendorActionCenter', 'upcomingDeliveries', 'purchaseOrders'],
    canAccess: ['vendor'],
  },
};

export const DEFAULT_ROLE = 'finance_user';

export function getRolePermissions(role) {
  return ROLE_PERMISSIONS[role] || ROLE_PERMISSIONS[DEFAULT_ROLE];
}

export function getAvailableRoles() {
  return Object.keys(ROLE_PERMISSIONS);
}

export function getKpiCount(role) {
  const perms = getRolePermissions(role);
  return perms.kpis.length;
}

export function getInsightCount(role) {
  const perms = getRolePermissions(role);
  return perms.insights.length;
}
